export class Collection<T = any> implements Iterable<T> {

    protected list: Array<T> = [];

    public model: any;

    /**
     * Factory method to return new instance of collection
     *
     * @param data
     * @param model
     * @returns {ApiCollection}
     */
    public static make<T = any>(data: Array<T>, model?: Object) {

        return new Collection<T>(data, model);

    }

    /**
     * Construct instance of collection
     *
     * @param data
     * @param model
     */
    constructor(data?: Array<T>, model?) {
        if (model) {
            this.model = model;
        }

        if (data) {
            if (!this.isDataValid(data)) {
                throw new Error('Collection data should be an array, ' + typeof data + 'given');
            }

            for (const line of data) {
                this.push(line);
            }
        }
    }

    protected isDataValid(data: any) {
        if (data) {
            if (data instanceof Array) {
                return true;
            }
        }

        return false;
    }

    public all() {

        return this.list;

    }

    public count() {

        return this.list.length;

    }

    public has(item) {

        return this.list.indexOf(item) >= 0;

    }

    public slice(start?: number, end?: number) {

        return this.list.slice(start, end);

    }

    public push(item) {

        if (this.model) {
            this.list.push(this.model.make(item, null));
        } else {
            this.list.push(item);
        }

        return item;
    }

    public each(callback) {
        for (const index in this.list) {
            callback(this.list[index], index);
        }
    }

    /**
     * Remove from collection
     *
     * @param key
     * @param value
     */
    public forget(key, value) {

        this.list = this.list.filter(model => model[key] !== value);

    }

    public first() {
        return this.list[0];
    }

    /**
     * Find instance in list
     *
     * @param key
     * @param value
     * @returns {undefined|any}
     */
    public find(key, value) {
        return this.list.find(item => item[key] === value);
    }

    public indexOf(item) {

        return this.list.indexOf(item);

    }

    /**
     * Returns the model count
     *
     * @returns {number}
     */
    get length() {
        return this.list.length;
    }

    /**
     * Dummy length setter (must exist to prevent errors)
     *
     * @param value
     */
    set length(value) {
    }

    /**
     * Iterate trough object models
     *
     * @param callbackfn
     * @param thisArg
     */
    public forEach(callbackfn: (value: any, index: number, array: any[]) => void, thisArg?: any): void {
        this.list.forEach(callbackfn, thisArg);
    }

    /**
     * Iterate trough object models
     *
     * @param callback
     */
    public filter(callback): Collection {
        return new Collection(this.list.filter(callback));
    }

    public reduce(callback, initialValue) {
        return this.list.reduce(callback, initialValue);
    }

    /**
     * The mapWithKeys method iterates through the collection and passes each value to the given
     * callback. The callback should return an associative array containing a single key / value
     * pair.
     *
     * @param callback
     * @returns {{}}
     */
    public mapWithKeys(callback) {
        const array = {};

        for (const item of this.list) {
            const value = callback(item);

            array[value.key] = value.value;
        }

        return array;
    }

    public clear() {
        this.list = [];

        return this;
    }

    public fill(array: Array<any>) {
        this.list = this.list.concat(array);

        return this;
    }

    public clone(items?: Array<any>) {
        const clone = Object.assign(new Collection, this);

        if (items) {
            clone.clear();
            clone.fill(items);
        }

        return clone;
    }

    /**
     * Magic iterator loops over models
     *
     * @returns {any}
     */
    public [Symbol.iterator]() {

        let pointer  = 0;
        const models = this.list;

        return {

            next(): IteratorResult<any> {
                if (pointer < models.length) {
                    return {
                        done: false,
                        value: models[pointer++]
                    };
                } else {
                    return {
                        done: true,
                        value: null
                    };
                }
            }

        };

    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/collection/collection.ts